import { useEffect } from 'react';
import { useStore } from 'context/StoreContext';
import { revealApp } from './snapshotHandoff';

/**
 * Pages call this with `true` once their main content is rendered (data
 * loaded, or an error or not-found state shown). When the visit started on a
 * server-rendered snapshot, React is revealed then, and only once the shop
 * profile has answered too, so the header never shows its loading skeleton
 * in place of the snapshot. No-op otherwise.
 */
export default function usePageReady(ready = true) {
  const { isLoading } = useStore();
  useEffect(() => {
    if (ready && !isLoading) revealApp();
  }, [ready, isLoading]);
}
